import { Component, OnInit } from '@angular/core';
import { DataModelService } from '@services/data-model.service';
import { NotificationsService } from '@services/notifications.service';

@Component({
    selector: 'app-type-config',
    templateUrl: './type-config.component.html',
    styleUrls: [
        '../data-model-prefs/data-model-prefs.component.scss',
        './type-config.component.scss',
    ],
    standalone: false
})
export class TypeConfigComponent implements OnInit {
  typeList = [];
  dataCategories = [];

  selectedType;

  constructor(
    private dataModelService: DataModelService,
    private notifications: NotificationsService
  ) {}

  ngOnInit() {
    this.dataModelService.getCategories().subscribe(list => {
      this.dataCategories = list;
    });

    this.dataModelService.getTypes().subscribe(list => {
      this.typeList = list;
    });
  }

  updateCategory() {
    this.dataModelService
      .updateType(this.selectedType.id, this.selectedType.category)
      .subscribe(data => {
        if (data && data.errorMessage) {
          this.notifications.popNotification(data.errorMessage, 'X');
        } else {
          this.dataModelService.updateTypes();
        }
      });
  }
}
